import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import FaqAccordion from "../components/FaqAccordion";
import { questions } from "./questions";

function Faq() {
  const [expanded, setExpanded] = useState("");

  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      <Box
        minHeight="60vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <img
          src="./capa2.png"
          style={{
            objectFit: "contain",
            width: "365px",
            maxWidth: "100%",
            height: "auto",
          }}
          alt="Portal do cliente - FAQ"
        />
        <Box
          maxWidth={{
            xs: "90vw",
            md: "60vw",
          }}
          mt={5}
          mb={{
            xs: 5,
            md: 0,
          }}
        >
          <Typography
            variant="h1"
            fontSize="24px"
            fontWeight="medium"
            sx={{
              width: {
                xs: "90vw",
                md: "40vw",
              },
            }}
          >
            Sabemos que algumas dúvidas podem surgir no meio do percurso, por isso, esperamos que
            este FAQ te ajude a lidar com as principais delas.
          </Typography>
        </Box>
      </Box>

      <Box
        minHeight="40vh"
        bgcolor="#A58AB6"
        display="grid"
        alignContent="center"
        justifyContent="center"
        py={8}
      >
        <Box
          width={{
            xs: "90vw",
            md: "60vw",
          }}
          maxWidth={{
            xs: "90vw",
            md: "60vw",
          }}
        >
          <Typography variant="h2" fontSize="36px" fontWeight="bold" color="common.white">
            Principais dúvidas:
          </Typography>

          <Box my={3}>
            {questions.map((question, index) => (
              <>
                <FaqAccordion
                  title={question.title}
                  answer={question.answer}
                  expanded={expanded}
                  handleChangeAccordion={handleChangeAccordion}
                />
                {index < questions.length - 1 && <Box my={0.3} />}
              </>
            ))}
          </Box>
        </Box>
      </Box>

      <Box
        minHeight="8vh"
        bgcolor="#666666"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h1" fontSize="12px" color="common.white" fontWeight="bold">
          GRUPO MEDSYSTEMS
        </Typography>
      </Box>
    </Box>
  );
}

export default Faq;
